export default "__VITE_ASSET__DCe9qH46__"